import raw from './tokenDecimals.json'

export interface TokenMeta {
  symbol: string
  decimals: number
}

const entries = Object.entries(raw as Record<string, TokenMeta | string>).filter(
  (entry): entry is [string, TokenMeta] => entry[0].startsWith('0x'),
)

/** Lowercase address -> { symbol, decimals }. See tokenDecimals.json for provenance. */
export const TOKEN_DECIMALS: Record<string, TokenMeta> = Object.fromEntries(
  entries.map(([addr, meta]) => [addr.toLowerCase(), meta]),
)

export function lookupToken(address: string | null | undefined): TokenMeta | null {
  if (!address) return null
  return TOKEN_DECIMALS[address.toLowerCase()] ?? null
}
